<template>
  <button @click="emit('click')" type="submit" class="hover:drop-shadow-blue-1 flex h-16 items-center bg-red p-5 text-white">
    <p class="font-lexend text-subtitle-2 font-medium">
      {{ label }}
    </p>
  </button>
</template>

<script lang="ts" setup>
import { IConfirmationButtonEmits } from '@/interfaces/components/emits'

defineProps<{ label: string }>()

const emit = defineEmits<IConfirmationButtonEmits>()
</script>
